export default __webpack_public_path__ + "static/media/Q5_4_resized.187e4e4c.jpg";